import { render } from "./ShoppingCartPage.vue?vue&type=template&id=45a9dc88&ts=true"
import script from "./ShoppingCartPage.vue?vue&type=script&lang=ts"
export * from "./ShoppingCartPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__